<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <section id="methodology" class="screen">
        <CommonShapeAnimation shape="polygon" :sides="3" :rotation="75" position="left" />
        <div class="content">
            <div class="wrapper col-2">
                <div class="intro">
                    <h2>Notre méthode</h2>
                    <p><strong>Une Alchimie créative pour transformer vos idées en succès ?</strong></p>
                    <p>Voici nos clefs pour mener une idée vers un projet abouti.<br>Contactez-nous dès aujourd’hui et
                        faisons naître ensemble des projets ambitieux et mémorables.
                    </p>
                    <a id="methodology-header-action" @click="clickHandler('contact')" title="Contactez-nous">
                        <CommonButton size="large" icon="next">Je me lance</CommonButton>
                    </a>
                </div>
                <div class="row-3">
                    <article class="panel col-2">
                        <div class="icon">
                            <IconBrain />
                        </div>
                        <div>
                            <header>
                                <h3>Réflexion</h3>
                            </header>
                            <p><strong>Une écoute active pour révéler vos besoins.</strong></p>
                            <p>Nous analysons vos idées et vos objectifs pour construire un cadre stratégique et créatif
                                qui met en lumière le potentiel de votre projet.</p>
                        </div>
                    </article>
                    <article class="panel col-2">
                        <div class="icon">
                            <IconDesign />
                        </div>
                        <div>
                            <header>
                                <h3>Structuration</h3>
                            </header>
                            <p><strong>Quand l’inspiration devient réalité.</strong></p>
                            <p>Avec passion et précision, nous traduisons vos aspirations en maquettes et expériences
                                impactantes. Chaque décision est un pas vers l’excellence.</p>
                        </div>
                    </article>
                    <article class="panel col-2">
                        <div class="icon">
                            <IconComplete />
                        </div>
                        <div>
                            <header>
                                <h3>Accomplissement</h3>
                            </header>
                            <p><strong>L’exécution parfaite.</strong></p>
                            <p>Nous réalisons et peaufinons chaque détail avant de vous livrer un produit prêt à
                                impressionner et à performer.</p>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import IconBrain from "@/components/icons/IconBrain.vue";
import IconDesign from "@/components/icons/IconDesign.vue";
import IconComplete from "@/components/icons/IconComplete.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";

const clickHandler = (name: string) => {
    trackButtonClick(`methodology-header-${name}`);
    scrollToSection(name);
}
</script>

<style lang="sass">
</style>